// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/mns-core-ui-header/templates/header/styles.scss
// module id = 43
// module chunks = 0